import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
// import '../../../../../control/strings/style.css';
import AnalyticsAccess from '../../../dataAccess/AnalyticsAccess';
import SearchMeasure from '../../../components/SearchMeasure';
import AnalyticsDataSkeleton from './skeleton/AnalyticsDataSkeleton';
import MeasuresList from '../../../components/MeasuresList';
import { useNavigate } from 'react-router-dom';

const DashboardView = (props) => {
  const [measures, setMeasures] = useState(null);
  const [filteredMeasures, setFilteredMeasures] = useState(null);
  const topFilterData = useSelector(state => state.widgetFiltes);

  const [skeleton, setSkeleton] = useState(true);
  const navigate = useNavigate();
  const { clientId} = props;
  const callTriskeleApi = () => {
    AnalyticsAccess.getReports(clientId)
      .then((response) => {
        console.log('response', response);
        let result = [];
        if (response.data && response.data.length > 0) {
          if (props.headerTitle != null) {
            const map = new Map();
            const analyticsMeasures = response.data;
            for (let index = 0; index < analyticsMeasures.length; index += 1) {
              if (analyticsMeasures[index].PrcsParmtrValueOne === 'Header' && !map.has(analyticsMeasures[index].ReportCtgyName) && topFilterData.widgetFiltes.indexOf(analyticsMeasures[index].ReportCtgyName) > -1) {
                map.set(analyticsMeasures[index].ReportCtgyName, true);
                result.push({
                  name: analyticsMeasures[index].ReportCtgyName,
                  order: props.headerTitle === analyticsMeasures[index].ReportCtgyName
                    ? -1 : parseInt(analyticsMeasures[index].ReportCtgySortOrdr, 0),
                  values: response.data.filter(x => x.ReportCtgyName === analyticsMeasures[index].ReportCtgyName && x.PrcsParmtrValueOne !== 'Header' && x.ReportName !== 'High Intensity Interval Training' && x.ReportName !== 'Preparation & Recovery')
                    .sort((a, b) => parseInt(a.ReportSortOrdr, 0) - parseInt(b.ReportSortOrdr, 0))
                });
              }
            }

            result = result.sort((a, b) => a.order - b.order);
          } else { // Click Analytics a
            const headers = response.data.filter(x => x.PrcsParmtrValueOne === 'Header' && topFilterData.widgetFiltes.indexOf(x.ReportCtgyName) > -1);
            for (let index = 0; index < headers.length; index += 1) {
              result.push({
                name: headers[index].ReportCtgyName,
                values: response.data.filter(x => x.ReportCtgyName === headers[index].ReportCtgyName && x.PrcsParmtrValueOne !== 'Header' && x.ReportName !== 'High Intensity Interval Training' && x.ReportName !== 'Preparation & Recovery')
                  .sort((a, b) => parseInt(a.ReportSortOrdr, 0) - parseInt(b.ReportSortOrdr, 0))
              });
            }
          }
        }
        result = result.filter(x => x);

        setMeasures(result);
        setSkeleton(false);
        setFilteredMeasures(result);
      })
      .catch((error) => {
        setSkeleton(false);
        navigate('/maintenance');
      });
  };

  useEffect(() => {
    callTriskeleApi();
  }, [topFilterData]);

  // TEMP: hardcoded report overrides until these measures get their own ReportID from the API
  const getReportId = (measure) => {
    const name = (measure.ReportName || '').toLowerCase();
    if (name.includes('flights climbed') || name.includes('steps')) {
      return '166c8560-4d9f-42f2-a031-0cbab8844cbc';
    }
    if (name.includes('calorie')) {
      return '48b9c2e7-cca0-40c3-a98d-46154649f6c4';
    }
    return measure.ReportID;
  };

  const goToChart = (measure) => {
    navigate('/home/analytics/chart?clientid=' + clientId, {
      state: {
        datasetId: measure.DatasetID,
        reportId: getReportId(measure),
        measureId: measure.MeasureId,
        clientId: clientId
      }
    });
  };

  return (
    <div>

      <SearchMeasure
        measures={measures}
        onFilteredMeasures={setFilteredMeasures}
                />
      <div>
        {skeleton && <AnalyticsDataSkeleton columns="4" />}

        <MeasuresList
          filteredMeasures={filteredMeasures}
          setAction={goToChart}
          container="grid-container"
          type="report"
                    />
      </div>

    </div>

  );
};

export default DashboardView;
